import { render, staticRenderFns } from "./CardComponent.vue?vue&type=template&id=1ded894d&"
import script from "./CardComponent.vue?vue&type=script&lang=js&"
export * from "./CardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\www\\aliventa\\gruene-hex\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ded894d')) {
      api.createRecord('1ded894d', component.options)
    } else {
      api.reload('1ded894d', component.options)
    }
    module.hot.accept("./CardComponent.vue?vue&type=template&id=1ded894d&", function () {
      api.rerender('1ded894d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardComponent.vue"
export default component.exports